export const knowledgeSourceToolType = "knowledge_source" as const;

export interface KnowledgeSourceToolConfig {
  tool_type: typeof knowledgeSourceToolType;
  definition_id: string;
  excluded_fields: string[];
}

export type ToolConfig = KnowledgeSourceToolConfig;

export interface ConversationalWorkflowStep {
  instruction: string;
  tool_configs: ToolConfig[];
}

export interface ConversationalWorkflowChatSetting {
  app_ids: string[];
}

export interface ConversationalWorkflowMessagingChannelSetting {
  subscription_group_ids: string[];
}

export interface ConversationalWorkflowResultObject {
  id: string;
  name: string;
  purpose: string;
  steps: ConversationalWorkflowStep[];
  chat_setting: ConversationalWorkflowChatSetting | null;
  messaging_channel_setting: ConversationalWorkflowMessagingChannelSetting | null;
  created_by_email: string;
  created_at: string;
  updated_at: string;
}

export interface ConversationalWorkflowResult {
  result: ConversationalWorkflowResultObject;
}

export interface GetConversationalWorkflowProps {
  appGroupId: string;
  workflowId: string;
}

export interface ConversationalWorkflowPayload {
  id?: string;
  name: string;
  purpose: string;
  steps: ConversationalWorkflowStep[];
  chat_setting: ConversationalWorkflowChatSetting;
  messaging_channel_setting: ConversationalWorkflowMessagingChannelSetting;
}

export interface PostConversationalWorkflowProps extends ConversationalWorkflowPayload {
  appGroupId: string;
}

export interface PutConversationalWorkflowProps extends ConversationalWorkflowPayload {
  appGroupId: string;
  workflowId: string;
}

export interface PostConversationalPreviewWorkflowProps {
  appGroupId: string;
  sessionId: string;
  userMessage: string;
  conversationalWorkflowPayload: ConversationalWorkflowPayload;
}

export interface PostConversationalPreviewWorkflowResult {
  message_id: string;
}
